import { Component, Input, TemplateRef } from '@angular/core';
import { AvailbleBSPositions } from 'ngx-bootstrap/positioning/models';

@Component({
	selector: 'app-circle-info-tooltip',
	templateUrl: './circle-info-tooltip.component.html',
	styleUrls: ['./circle-info-tooltip.component.scss'],
})
export class CircleInfoTooltipComponent {
	@Input() toolTipText: string | TemplateRef<any> = '';
	@Input() placement: AvailbleBSPositions = 'left';
}
